import { Badge } from '@chakra-ui/react';
import { HostState, OverallStatus } from '../types';

const STATUS_PALETTE: Record<OverallStatus, string> = {
  up: 'green',
  degraded: 'yellow',
  down: 'red',
  unknown: 'gray',
};

export function StatusBadge({ status }: { status: OverallStatus }) {
  return (
    <Badge colorPalette={STATUS_PALETTE[status]} variant='solid'>
      {status}
    </Badge>
  );
}

export function StateBadge({ state }: { state: HostState }) {
  return (
    <Badge colorPalette={state === 'deployed' ? 'blue' : 'orange'} variant='surface'>
      {state}
    </Badge>
  );
}
